import { useTranslation } from 'react-i18next';
import { useNavigate } from '@tanstack/react-router';
import { Button } from '../shared/ui/Button';

export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className="mx-auto max-w-md rounded-2xl bg-surface px-6 py-16 text-center shadow-card">
      <h1 className="text-2xl font-bold text-fg">{t('errors.notFoundTitle')}</h1>
      <p className="mt-2 text-fg-muted">{t('errors.notFoundSubtitle')}</p>
      <Button className="mt-6" onClick={() => void navigate({ to: '/' })}>
        {t('errors.notFoundCta')}
      </Button>
    </div>
  );
}
